import { render, staticRenderFns } from "./FourthStep.vue?vue&type=template&id=b063325e&"
import script from "./FourthStep.vue?vue&type=script&lang=js&"
export * from "./FourthStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports